import { useSWR } from '~/hooks/useSWR';

import { EmployeeFormType, getEmployeeForms } from '.';

export const useGetEmployeeForms = (employeeId: number) => {
  const { data, ...rest } = useSWR(['employeeForms', employeeId], () =>
    getEmployeeForms(employeeId.toString()).then((data) => {
      return data.sort((a: EmployeeFormType, b: EmployeeFormType) => {
        return (
          new Date(b.fEmpFormCreatedTime).valueOf() -
          new Date(a.fEmpFormCreatedTime).valueOf()
        );
      });
    }),
  );

  return {
    data: data ?? [],
    ...rest,
  };
};
